import { FileX } from 'lucide-react'
import { FileFieldInput } from '../../FileFieldInput'
import { ReadValuePlaceholder } from './ReadValuePlaceholder'
import { useFieldDensity } from '../FieldDensity'
import type { FieldDefinition } from '../../../types'

/**
 * Read-mode dla pola FILE. Zachowanie identyczne z oryginalnym FieldRenderer:
 * gdy contractId + documentTypeId są dostępne, renderuje {@code FileFieldInput}
 * w trybie disabled (pokaże thumbnail/nazwę pliku LUB własny placeholder gdy
 * value=null). Bez {@code documentTypeId} -- spadamy do generic "—".
 *
 * W trybie compact (sidebar) placeholder "Brak pliku" jest mniejszy.
 * Non-empty przypadek deleguje do FileFieldInput - ten sam komponent, density-aware.
 */
export function FileReadView({
  field, value, contractId,
}: { field: FieldDefinition; value: unknown; contractId?: number }) {
  const density = useFieldDensity()
  const fileId = typeof value === 'number' ? value : null

  if (fileId == null) {
    if (density === 'compact') {
      return (
        <div className="flex items-center gap-1.5 text-slate-400 py-0.5">
          <FileX size={13} />
          <span className="text-xs">Brak pliku</span>
        </div>
      )
    }
    // Comfortable - Read-only z brakującą wartością renderowało wcześniej disabled dropzone (mylące --
    // wyglądało jak edit-area). Pokazujemy placeholder z ikonką pasujący wysokością
    // do non-empty FileFieldInput (h-28).
    return (
      <div className="h-[72px] flex flex-col items-center justify-center gap-1 rounded-md border border-dashed border-slate-200 bg-slate-50/40 text-slate-400">
        <FileX size={18} />
        <span className="text-xs">Brak pliku</span>
      </div>
    )
  }
  if (contractId && field.documentTypeId) {
    return (
      <FileFieldInput
        contractId={contractId}
        documentTypeId={field.documentTypeId}
        value={fileId}
        onChange={() => { /* read-only - no-op */ }}
        disabled
      />
    )
  }
  return <ReadValuePlaceholder display="—" />
}
